const CardIcon = () => {
  return (
    <svg width="68" height="48" viewBox="0 0 68 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M57.3307 4C58.6568 4 59.9286 4.52678 60.8663 5.46447C61.8039 6.40215 62.3307 7.67392 62.3307 9V14H45.6641V44H22.3307V4H57.3307ZM21.4974 34V44H10.6641C9.33798 44 8.06621 43.4732 7.12853 42.5355C6.19085 41.5979 5.66406 40.3261 5.66406 39V34H21.4974ZM62.3307 34V39C62.3307 40.3261 61.8039 41.5979 60.8663 42.5355C59.9286 43.4732 58.6568 44 57.3307 44H46.4974V34H62.3307ZM62.3307 24.8333V33.1667H46.4974V24.8333H62.3307ZM21.4974 24.8333V33.1667H5.66406V24.8333H21.4974ZM62.3307 14.8333V24H46.4974V14.8333H62.3307ZM21.4974 14.8333V24H5.66406V14.8333H21.4974ZM21.4974 4V14H5.66406V9C5.66406 7.67392 6.19085 6.40215 7.12853 5.46447C8.06621 4.52678 9.33798 4 10.6641 4L21.4974 4Z"
        fill="url(#paint0_linear_541_137753)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_541_137753"
          x1="9.96406"
          y1="7"
          x2="40.5641"
          y2="48.4"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#DCA728" />
          <stop offset="0.300537" stopColor="#FBCA64" />
          <stop offset="0.688348" stopColor="#C9952C" />
          <stop offset="1" stopColor="#EFBD56" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default CardIcon
